// extracted by mini-css-extract-plugin
module.exports = {"page":"signUp_page__kg0RI","form":"signUp_form__2n1el","agreeButton":"signUp_agreeButton__2HXqd","inputIcon":"signUp_inputIcon__2D9Qv","logo":"signUp_logo__3t4-S"};